module.exports = __webpack_public_path__ + "static/5-Podium-Landscape-view-eye-level-1-48908d3c31012fc7c36c43836c9ba382.jpg";